module.exports = __webpack_public_path__ + "static/img_3.4b95b37d.png";